<template>
  <el-col :span="24">
    <div
      class="ma-0"
      v-loading="loading"
      :element-loading-spinner="svg"
      element-loading-svg-view-box="-10, -10, 50, 50"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >
    <div class="custom-table-design">
      <el-table
        :data="userDataList"
        :fit="true"
        stripe
        height="300"
        :row-class-name="tableRowClassName"
        @row-click="handleRowClick"
        class="my-2 data-table"
        scrollbar-always-on: false
      >
        <el-table-column
          v-if="$vuetify.display.width >= 500"
          type="expand"
          class="coloo"
        >
          <template #default="props">
            <div class="pa-5">
              <p class="mb-1" v-if="$vuetify.display.width <= 1200">
                <b>State :</b>
                {{ props.row.state == null ? "-" : props.row.state }}
              </p>
              <p class="mb-1" v-if="$vuetify.display.width <= 1200">
                <b>City :</b>
                {{ props.row.city == null ? "-" : props.row.city }}
              </p>
              <p class="mb-1" v-if="$vuetify.display.width <= 1200">
                <b>Suburb :</b>
                {{ props.row.suburb == null ? "-" : props.row.suburb }}
              </p>
              <p class="mb-1" v-if="$vuetify.display.width <= 1200">
                <b>Street :</b>
                {{ props.row.street == null ? "-" : props.row.street }}
              </p>
              <p class="mb-1">
                <b>Address Comment :</b>
                {{
                  props.row.address_comment == null
                    ? "-"
                    : props.row.address_comment
                }}
              </p>
              <p class="mb-1">
                <b>Site Description :</b> {{ props.row.description }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="'Customer'"
          :prop="'full_name'"
          :width="$vuetify.display.width <= 1600 ? 200 : ''"
          sortable
          >
            <template #default="scope">
              {{
              scope.row.full_name == null
                  ? ""
                  : (scope.row.full_name).replaceAll("_", " ")
              }}
            </template>
        </el-table-column>
        <el-table-column
          :label="'Site Name'"
          :prop="'title'"
          :width="$vuetify.display.width <= 1600 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Country'"
          :prop="'country'"
          :width="$vuetify.display.width <= 1600 ? 180 : ''"
          sortable
        />
        <el-table-column
          v-if="$vuetify.display.width > 1200"
          :label="'State'"
          :prop="'state'"
          :width="$vuetify.display.width <= 1600 ? 180 : ''"
          sortable
          >
            <template #default="scope">
              {{
              scope.row.state == null
                  ? ""
                  : (scope.row.state).toUpperCase().replaceAll("_", " ")
              }}
            </template>
          </el-table-column>
        <el-table-column
          v-if="$vuetify.display.width > 1200"
          :label="'City'"
          :prop="'city'"
          :width="$vuetify.display.width <= 1600 ? 180 : ''"
          sortable
        />
        <el-table-column
          v-if="$vuetify.display.width > 1200"
          :label="'Suburb'"
          :prop="'suburb'"
          :width="$vuetify.display.width <= 1600 ? 180 : ''"
          sortable
        />
        <el-table-column
          v-if="$vuetify.display.width > 1200"
          :label="'Street Name'"
          :prop="'street_name'"
          :width="$vuetify.display.width <= 1600 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Postcode'"
          :prop="'postcode'"
          :width="$vuetify.display.width <= 1600 ? 150 : ''"
          sortable
        />
        <el-table-column
          :label="'Elec Region'"
          :prop="'elec_region'"
          :width="$vuetify.display.width <= 1600 ? 160 : ''"
          sortable
        >
            <template #default="scope">
              {{
              scope.row.elec_region == null
                  ? ""
                  : (scope.row.elec_region).toUpperCase().replaceAll("_", " ")
              }}
            </template>
        </el-table-column>
        <el-table-column
          :label="'Created At'"
          :prop="'created_at'"
          :width="$vuetify.display.width <= 1600 ? 160 : ''"
          sortable
        >
            <template #default="scope">
              {{
              scope.row.created_at == null
                  ? ""
                  : (scope.row.created_at).toUpperCase().replaceAll("T", " ")
              }}
            </template>
        </el-table-column>
        <el-table-column
          :label="'Site Updated At'"
          :prop="'updated_at'"
          :width="$vuetify.display.width <= 1600 ? 160 : ''"
          sortable
        >
        <template #default="scope">
              {{
              scope.row.updated_at == null
                  ? ""
                  : (scope.row.updated_at).toUpperCase().replaceAll("T", " ")
              }}
            </template>
        </el-table-column>
        <el-table-column
          v-if="$vuetify.display.width < 500"
          :label="'Operations'"
          :prop="'operations'"
          align="center"
          width="250"
        >
          <template #default="scope">

            <el-tooltip placement="top" effect="light">
                        <template #content>{{
                  $store.state.auth.user != null &&
                  !$store.state.auth.user.is_auditor
                    ? "Update"
                    : "Show"
                }}</template>
                        <el-button
                          v-if="
                            scope.row.id != null && scope.row.id != ''
                          "
                          @click.stop="handleUpdate(scope.$index, scope.row)"
                          size="small"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationEdit"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>

                      <el-tooltip placement="top" effect="light">
                        <template #content>Delete</template>
                        <el-button
                            v-if="
                              $store.state.auth.user != null &&
                              !$store.state.auth.user.is_auditor
                            "
                          @click.stop="handleDelete(scope.$index, scope.row)"
                          size="small"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>

                      <el-tooltip
                        v-if="isAdminUser && siteNameForReset(scope.row)"
                        placement="top"
                        effect="light"
                      >
                        <template #content>Reset elec region</template>
                        <el-button
                          @click.stop="handleResetElecRegion(scope.row)"
                          size="small"
                          :disabled="isResettingElecRegionRow(scope.row)"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationReset"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          fixed="right"
          :label="'Operations'"
          :prop="'operations'"
          align="center"
          width="250"
        >
          <template #default="scope">
            <el-tooltip placement="top" effect="light">
                        <template #content>{{
                  $store.state.auth.user != null &&
                  !$store.state.auth.user.is_auditor
                    ? "Update"
                    : "Show"
                }}</template>
                        <el-button
                          v-if="
                            scope.row.id != null && scope.row.id != ''
                          "
                          @click.stop="handleUpdate(scope.$index, scope.row)"
                          size="small"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationEdit"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>

                      <el-tooltip placement="top" effect="light">
                        <template #content>Delete</template>
                        <el-button
                            v-if="
                              $store.state.auth.user != null &&
                              !$store.state.auth.user.is_auditor
                            "
                          @click.stop="handleDelete(scope.$index, scope.row)"
                          size="small"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>

                      <el-tooltip
                        v-if="isAdminUser && siteNameForReset(scope.row)"
                        placement="top"
                        effect="light"
                      >
                        <template #content>Reset elec region</template>
                        <el-button
                          @click.stop="handleResetElecRegion(scope.row)"
                          size="small"
                          :disabled="isResettingElecRegionRow(scope.row)"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationReset"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
      <el-row class="row-bg" justify="space-between">
        <el-col
          :span="5"
          class="d-flex justify-content-start align-items-center"
        >
          <el-select
            v-model="perPageCount"
            placeholder="Select"
            size="small"
            style="width: 70px"
          >

              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
          </el-select>
        </el-col>
        <el-col
          :span="8"
          class="d-flex align-items-center justify-content-center"
        >
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="total_items"
            v-model:page-size="page_size"
            v-model:current-page="current_page"
            @current-change="changePage"
            class="my-4"
          />
        </el-col>
        <el-col :span="5" class="d-flex justify-content-end align-items-center">
          <span class="text-white">
            {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
              current_page * perPageCount > total_items
                ? total_items.toLocaleString()
                : (current_page * perPageCount).toLocaleString()
            }}
            of {{ total_items.toLocaleString() }}
          </span>
        </el-col>
      </el-row>
    </div>

    <div class="custom-pagination" v-if="$vuetify.display.width < 700">
      <el-row class="row-bg" justify="space-between">
        <el-col
          :span="24"
          class="d-flex align-items-center justify-content-center"
        >
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="total_items"
            v-model:page-size="page_size"
            v-model:current-page="current_page"
            @current-change="changePage"
            class="my-4"
          />
        </el-col>
        <el-col
          :span="10"
          class="d-flex justify-content-end align-items-center"
        >
          <el-select
            v-model="perPageCount"
            placeholder="Select"
            size="small"
            style="width: 70px"
          >
              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
          </el-select>
        </el-col>
        <el-col :span="10" class="d-flex justify-content-start align-items-center">
          <span class="text-white">
            {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
              current_page * perPageCount > total_items
                ? total_items.toLocaleString()
                : (current_page * perPageCount).toLocaleString()
            }}
            of {{ total_items.toLocaleString() }}
          </span>
        </el-col>
      </el-row>
    </div>

    </div>
  </el-col>
</template>

<script>
import { ElMessageBox } from "element-plus";
import { useToast } from "vue-toastification";
import UserService from "../../services/user.service";
export default {
  props: {
    loadingProp: {
      type: Boolean,
      default: false,
    },
    usersDataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
    totalRowProp: {
      type: Number,
    },
  },
  components: {
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      userDataList: [],
      search: "",
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
      resettingElecRegionBySite: {},
    };
  },
  computed: {
    isAdminUser() {
      return (
        this.$store.state.auth.user != null &&
        this.$store.state.auth.user.is_admin &&
        !this.$store.state.auth.user.is_auditor
      );
    },
  },
  watch: {
    loadingProp: {
      handler: function (newValue) {
        this.loading = newValue;
      },
      deep: true,
    },
    usersDataProp: {
      handler: function (newValue) {
        this.userDataList = newValue;
      },
      deep: true,
    },
    totalRowProp: {
      handler: function (newValue) {
        this.total_items = newValue;
        console.log(this.total_items);
      },
      deep: true,
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      this.$emit("tableAction", {
        index: this.page_size,
        data: null,
        kind: "perPageChange",
      });
    },
  },
  methods: {
    CopyCreateAt(created_at, customer_id) {
      // console.log('created_at', created_at);
      // console.log('customer_id', customer_id);
      this.$emit("tableAction", {
        created_at: created_at,
        customer_id: customer_id,
        kind: "copyCreateAt",
      });
    },
    handleRowClick(row, column, event) {
      console.log(row, column, event);
    },
    handleUpdate(index, data) {
      this.$emit("tableAction", { index: index, data: data, kind: "edit" });
    },
    handleDelete(index, event) {
      this.$emit("tableAction", { index: index, data: event, kind: "delete" });
    },
    siteNameForReset(row) {
      if (!row) return "";
      const name = row.title || row.site_name;
      return name == null ? "" : String(name).trim();
    },
    isResettingElecRegionRow(row) {
      const siteName = this.siteNameForReset(row);
      return !!(siteName && this.resettingElecRegionBySite[siteName]);
    },
    formatElecRegionLabel(value) {
      return value == null || value === "" ? "" : String(value);
    },
    async handleResetElecRegion(row) {
      const siteName = this.siteNameForReset(row);
      const customerId = row?.customer_id;
      if (!this.isAdminUser) {
        useToast().error("Admin only.", {
          icon: "fa fa-times",
          position: "bottom-right",
          timeout: 3000,
        });
        return;
      }
      if (!customerId) {
        useToast().error("Customer ID is required.", {
          icon: "fa fa-times",
          position: "bottom-right",
          timeout: 3000,
        });
        return;
      }
      if (!siteName) {
        useToast().error("Site name is required.", {
          icon: "fa fa-times",
          position: "bottom-right",
          timeout: 3000,
        });
        return;
      }
      if (this.resettingElecRegionBySite[siteName]) return;

      this.resettingElecRegionBySite[siteName] = true;
      try {
        await ElMessageBox.confirm(
          "This overwrites the site's electricity region from location data.",
          "Reset elec region",
          {
            confirmButtonText: "Reset",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        );
        const response = await UserService.resetUkElecRegion(customerId, siteName);
        const payload = response?.data?.data && response.data.old_elec_region === undefined
          ? response.data.data
          : (response?.data || {});
        const oldRegion = this.formatElecRegionLabel(payload.old_elec_region);
        const newRegion = this.formatElecRegionLabel(payload.new_elec_region);
        row.elec_region = payload.new_elec_region == null ? null : payload.new_elec_region;
        useToast().success(`elec_region: ${oldRegion} → ${newRegion}`, {
          icon: "fa fa-check",
          position: "bottom-right",
          timeout: 4000,
        });
        if (payload.new_elec_region == null || payload.new_elec_region === "") {
          useToast().warning("The electricity region could not be resolved from location data.", {
            icon: "fa fa-exclamation-triangle",
            position: "bottom-right",
            timeout: 5000,
          });
        }
        this.$emit("tableAction", { data: row, kind: "resetElecRegionDone" });
      } catch (error) {
        if (error === "cancel" || error === "close" || error?.action === "cancel") return;
        if (error?.response?.status == 401) {
          this.$router.push({ path: "/" });
          return;
        }
        const status = error?.response?.status;
        let message = error?.response?.data?.message || error?.message || "Failed to reset elec region.";
        if (status === 403) message = "Admin only.";
        else if (status === 404) message = "Charging site not found.";
        else if (status === 400) message = error?.response?.data?.message || "Invalid request.";
        useToast().error(message, {
          icon: "fa fa-times",
          position: "bottom-right",
          timeout: 4000,
        });
      } finally {
        this.resettingElecRegionBySite[siteName] = false;
      }
    },
    changePage(page) {
      this.$emit("tableAction", {
        index: page,
        data: null,
        kind: "changePage",
      });
    },
  },
};
</script>
